import React from 'react';

import { RouteContext } from 'ff/debrief/router';
import TracklogMapControls from 'ff/debrief/components/map/TracklogMapControls';
import Sidebar from 'ff/debrief/components/sidebar';
import FlightDetails from 'ff/debrief/components/details';
import ErrorBar from 'ff/debrief/components/ErrorBar';
import MapAreaGrid from 'ff/debrief/layouts/MapAreaGrid';
import { LinkToDebrief, LinkToHome } from 'ff/debrief/router';

export const pathString = '/:tracklogId?';

const HomeRoute = () => {
    return (
        <RouteContext.Provider
            value={{
                returnLink: LinkToHome,
                debriefLink: LinkToDebrief,
                page: 'TrackListView',
            }}
        >
            <MapAreaGrid>
                <TracklogMapControls />
                <Sidebar />
                <FlightDetails />
                <ErrorBar />
            </MapAreaGrid>
        </RouteContext.Provider>
    );
};

export default HomeRoute;
